import React from 'react';
import { Link as LinkOriginal } from 'gatsby';
import { observer, modal as modalStore } from 'store';
import { DOMAIN_URL } from 'define';
import { getHostname, isOwnDomain } from './utils';

const EN_DOMAIN_HOSTNAMES = [getHostname(DOMAIN_URL), 'people-andersenlab.com'];

function LinkGlobal({ className, href = '', children, onClick, state, target, ...other }) {
  if (EN_DOMAIN_HOSTNAMES.includes(getHostname(href))) {
    const handleClick = e => {
      e.preventDefault();
      modalStore.open('LangNotificationModal', { href, target });
    };

    return (
      <>
        <a className={className} onClick={e => handleClick(e)} href={href} {...other}>
          {children}
        </a>
      </>
    );
  }

  if (href.startsWith('/')) {
    return (
      <LinkOriginal onClick={onClick} className={className} to={href} state={state} {...other}>
        {children}
      </LinkOriginal>
    );
  }

  if (isOwnDomain(href)) {
    return (
      <a className={className} onClick={onClick} href={href} target={target} {...other}>
        {children}
      </a>
    );
  }

  return (
    <a
      className={className}
      onClick={onClick}
      href={href}
      target="_blank"
      rel="noreferrer noopener nofollow"
      {...other}
    >
      {children}
    </a>
  );
}

export default observer(LinkGlobal);
